import { ReqModel } from "src/app/shared/models/bases/base-req.model";

class Body {
    phoneNumber: string;
}

export class PME0611Req extends ReqModel {
  constructor() {
    super();
  }
  public body = new Body();
}
